/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the ingestion pipeline
*/
export enum IngestionPipelineStatus {
  INGESTION_PIPELINE_STATUS_DISABLED = 'DISABLED',
  INGESTION_PIPELINE_STATUS_ENABLED = 'ENABLED'
}
